module.exports = __webpack_public_path__ + "static/media/General Surgery-New Patient Intake-2@3x.d381ff98.png";